"use strict"; // Copyright (C) 2021 Toitware ApS. All rights reserved.
// Use of this source code is governed by an MIT-style license that can be
// found in the LICENSE file.

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotListeningError = exports.NotRunningError = exports.AlreadyRunningError = exports.ReadAlreadyInProgressError = exports.ConnectError = exports.TimeoutError = exports.ClosedError = exports.UnknownChipFamilyError = void 0;
exports.UnknownChipFamilyError = "Unknown chip family";
exports.ClosedError = "closed";
exports.TimeoutError = "timeout";
exports.ConnectError = "connect error";
exports.ReadAlreadyInProgressError = "Read already in progress";
exports.AlreadyRunningError = "already running";
exports.NotRunningError = "not running";
exports.NotListeningError = "not listening";